let WordRule = {
    createAcceptor: function (tag: any) {
        if (tag['WORD_RULE']) {
            return null
        }

        let objWordRule = {
            strOffset: 0,
            isFinal: false,

            transit: (ch: string) => {
                let lch = ch.toLowerCase()

                if (lch >= 'a' && lch <= 'z') {
                    objWordRule.isFinal = true
                    objWordRule.strOffset++
                } else {
                    objWordRule.isError = true
                }

                return objWordRule
            },

            isError: false,
            tag: 'WORD_RULE',
            type: 'WORD_RULE',
            w: 1,
        }

        return objWordRule
    },
}

let NumberRule = {
    createAcceptor: (tag: any) => {
        if (tag['NUMBER_RULE']) {
            return null
        }

        let objNumberRule = {
            strOffset: 0,
            isFinal: false,

            transit: (ch: string) => {
                let lch = ch.toLowerCase()

                if (lch >= 'a' && lch <= 'z') {
                    objNumberRule.isFinal = true
                    objNumberRule.strOffset++
                } else {
                    objNumberRule.isError = true
                }

                return objNumberRule
            },

            isError: false,
            tag: 'NUMBER_RULE',
            type: 'NUMBER_RULE',
            w: 1,
        }

        return objNumberRule
    },
}

let SpaceRule = {
    tag: 'SPACE_RULE',

    createAcceptor: function (tag: any) {
        if (tag['SPACE_RULE']) {
            return null
        }

        let objSpaceRule = {
            strOffset: 0,
            isFinal: false,

            transit: function (ch: string) {
                if (
                    ch === ' ' ||
                    ch === '\t' ||
                    ch === '\r' ||
                    ch === '\n' ||
                    ch === '\u00A0' ||
                    ch === '\u2003' //nbsp and emsp
                ) {
                    objSpaceRule.isFinal = true
                    objSpaceRule.strOffset++
                } else {
                    objSpaceRule.isError = true
                }
                return objSpaceRule
            },

            isError: false,
            tag: SpaceRule.tag,
            w: 1,
            type: 'SPACE_RULE',
        }

        return objSpaceRule
    },
}
var SingleSymbolRule = {
    tag: 'SINSYM',

    createAcceptor: function (tag: any) {
        let objSingleSymbolRule = {
            strOffset: 0,
            isFinal: false,

            transit: function (ch: string) {
                // eslint-disable-next-line no-useless-escape
                if (objSingleSymbolRule.strOffset === 0 && ch.match(/^[\@\(\)\/\,\-\."`]$/)) {
                    objSingleSymbolRule.isFinal = true
                    objSingleSymbolRule.strOffset++
                } else {
                    objSingleSymbolRule.isError = true
                }
                return objSingleSymbolRule
            },

            isError: false,
            tag: 'SINSYM',
            w: 1,
            type: 'SINSYM',
        }

        return objSingleSymbolRule
    },
}

export const LatinRules = [WordRule, NumberRule, SpaceRule, SingleSymbolRule]
